/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_OptionsInputs */

const en_loading_options = /** @type {(inputs: Loading_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading options...`)
};

const nl_loading_options = /** @type {(inputs: Loading_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opties laden...`)
};

/**
* | output |
* | --- |
* | "Loading options..." |
*
* @param {Loading_OptionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_options = /** @type {((inputs?: Loading_OptionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_OptionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_loading_options(inputs)
	return en_loading_options(inputs)
});